<template>
  <UHeader
    mode="slideover"
    toggle-side="right"
    :menu="{
      class: '',
      modal: true,
    }"
    :ui="{ left: 'lg:flex-1 flex items-center gap-1.5 h-full' }"
  >
    <template #body>
      <UNavigationMenu
        :ui="{
          link: 'group relative w-full flex items-center gap-1.5 font-medium text-lg font-mono before:absolute before:z-[-1] before:rounded-md focus:outline-none focus-visible:outline-none dark:focus-visible:outline-none focus-visible:before:ring-inset focus-visible:before:ring-2',
        }"
        type="single"
        orientation="vertical"
        :items="
          loggedIn ? loggedInItems.toReversed() : loggedOutItems.toReversed()
        "
      />
    </template>
    <template #left>
      <div
        class="h-full flex items-center cursor-pointer hover:opacity-90 transition-all"
      >
        <HeaderLogo />
      </div>
    </template>

    <div v-show="loggedIn && user.email_verified_at" class="h-full">
      <UNavigationMenu
        type="single"
        class="max-lg:hidden"
        :items="loggedInItems"
      />
    </div>
    <div v-show="!loggedIn" class="h-full">
      <UNavigationMenu
        type="single"
        class="max-lg:hidden"
        :items="loggedOutItems"
      />
    </div>

    <template #right>
      <UColorModeButton class="cursor-pointer" />

      <UDropdownMenu
        v-if="loggedIn"
        :items="dropdownItems"
        :content="{ side: 'bottom', align: 'end', sideOffset: 5 }"
      >
        <UButton
          size="lg"
          icon="solar:settings-linear"
          class="rounded-full cursor-pointer"
          variant="ghost"
          color="neutral"
        />
      </UDropdownMenu>
    </template>
    <template #toggle="{ open, toggle }">
      <UButton
        :icon="open ? 'mdi:close' : 'solar:hamburger-menu-linear'"
        variant="ghost"
        color="neutral"
        class="cursor-pointer -mr-1.5 lg:hidden"
        size="xl"
        @click="toggle"
      />
    </template>
  </UHeader>
</template>

<script setup lang="ts">
import type { DropdownMenuItem, NavigationMenuItem } from "@nuxt/ui";

const route = useRoute();
const { loggedIn, user } = useUserSession();

const dropdownItems = computed<DropdownMenuItem[][]>(() => {
  const items: DropdownMenuItem[][] = [
    [
      {
        label: "Profile",
        icon: "i-lucide-user",
        to: "/profile",
      },
      {
        label: "Logout",
        icon: "i-lucide-log-out",
        to: "/logout",
      },
      {
        type: "separator",
      },
      {
        label: "Get in touch",
        icon: "lucide:mail",
        to: "/get-in-touch",
      },
      {
        label: "Give feedback",
        icon: "lucide:user-round-pen",
        to: "/give-feedback",
      },
      {
        type: "separator",
      },
      {
        type: "label",
        label: "Logged in as: " + user.value?.username,
        class: "font-normal text-xs",
      },
    ],
  ];
  return items;
});

const loggedInItems = computed<NavigationMenuItem[]>(() => [
  {
    label: "Overview",
    to: "/dashboard",
    active: route.path === "/dashboard",
  },
  {
    label: "Projects",
    to: "/projects",
    active: route.path.startsWith("/projects"),
  },
  {
    label: "Work log",
    to: "/timelog",
    active: route.path.startsWith("/timelog"),
  },
]);

const loggedOutItems = computed<NavigationMenuItem[]>(() => [
  {
    label: "Get in touch",
    to: "/get-in-touch",
  },
  {
    label: "Create account",
    to: "/create-account",
    active: route.path.startsWith("/create-account"),
  },
]);
</script>
